import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './services/auth.service'; // Adjust the import path as needed
import { AuthStateService } from './services/auth-state.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'], // Updated to .scss
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'RevelBaseFrontend';
  currentUserIsAdmin: boolean = false;
  isLoginRoute: boolean = false;
  private authSubscription: Subscription = new Subscription();
  private routeSubscription: Subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private authStateService: AuthStateService,
    private router: Router
  ) {}

  ngOnInit() {
    // Subscribe to auth state changes
    this.authSubscription = this.authStateService.authChange$.subscribe(() => {
      this.refreshMenu();
    });

    // Initial check for admin status
    this.refreshMenu();

    this.updateRouteUi(this.router.url);
    this.routeSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigationEvent = event as NavigationEnd;
        this.updateRouteUi(navigationEvent.urlAfterRedirects);
      });
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }

  refreshMenu() {
    // Update the admin status based on the current user
    this.currentUserIsAdmin = this.authService.isCurrentUserAdmin();
  }

  private updateRouteUi(url: string) {
    this.isLoginRoute = url.startsWith('/login');
  }
}
